import Parsley from 'parsleyjs';
import 'parsleyjs/dist/i18n/zh_cn.js';
import 'parsleyjs/dist/i18n/ru.js';
import 'parsleyjs/dist/i18n/sv.js';
import 'parsleyjs/dist/i18n/pl.js';
import 'parsleyjs/dist/i18n/it.js';
import 'parsleyjs/dist/i18n/es.js';
import 'parsleyjs/dist/i18n/fr.js';
import 'parsleyjs/dist/i18n/nl.js';
import 'parsleyjs/dist/i18n/de.js';
import 'parsleyjs/dist/i18n/en.js';

var lang = document.documentElement.lang || 'en-gb';
if (lang.toLowerCase() === 'en-gb') {
  lang = 'en';
}
Parsley.setLocale(lang.toLocaleLowerCase());
